import { Formik } from "formik";
import React, { useState } from "react";
import { toast } from "react-toastify";
import * as yup from "yup";
import BankAccount from "../../components/BankAccount";
import FormikTextField from "../../components/Forms/FormikTextField";
import LoaderButton from "../../components/LoaderButton";
import photo1 from "../../images/verifybankaccount.svg";
import FormImage from "../../layouts/formimage";
import { Constants } from "../../libs/Constants";
import { update } from "../../libs/dbFunctions";

const initialValues = {
  amount1: 0,
  amount2: 0,
};
const schema = yup.object({
  amount1: yup.number().required("Amount is required"),
  amount2: yup.number().required("Amount is required"),
});

const VerifyBankAccount = (props) => {
  const [showAddBankAccount, setShowAddBankAccount] = useState(false);

  const handleSubmit = async (values) => {
    let saveFields = {
      ...props.userObj,
      verify_dwolla_customer_verified: true,
      amount1: values.amount1,
      amount2: values.amount2,
    };
    //update the userObj with salary and flags
    try {
      await update(Constants.dbTypes.USER, saveFields);
      toast.info(
        "Verification is in progress. It may take 2-3 days to complete the process."
      );
      await props.refreshUser();
      props.history.push("/");
    } catch (e) {
      if (e.response && e.response.data && e.response.data.error) {
        toast.error(e.response.data.error);
      } else {
        toast.error(e);
      }
    }
  };
  const handleSuccess = async (newAccount) => {
    //check the unverified account in the user accounts which is getting updated
    let unVerifiedAccount = null;
    if (props.userObj?.accounts && props.userObj.accounts.length > 0) {
      unVerifiedAccount = props.userObj.accounts.find(
        (acc) => acc.status === "unverified"
      );
    }
    if (unVerifiedAccount) {
      let saveFields = {
        id: unVerifiedAccount.id,
        newAccount,
      };
      //update the userObj with salary and flags
      try {
        await update(Constants.dbTypes.ACCOUNT, saveFields);
        await props.refreshUser();
        toast.success("Bank details updated successfully.");
        props.history.push("/");
      } catch (e) {
        if (e.response && e.response.data && e.response.data.error) {
          toast.error(e.response.data.error);
        } else {
          toast.error(e);
        }
      }
    } else {
      toast.error(
        "No Unverified Accounts for the user. Updation is not allowed."
      );
      props.history.push("/");
    }
  };

  return (
    <FormImage
      title="Keeping Everything Secure"
      subtitle="This verifies all the information is correct, and that there are no loose ends."
      image={photo1}
      bgClass="background-green"
    >
      <React.Fragment>
        <h2 className="text-center pb-3">Verify Bank Information</h2>
        {props.userObj && !props.userObj.dwolla_verification_inprogress && (
          <div className="text-center pb-3 font-secondary font-size-10">
            We transferred two amounts into your bank account.
          </div>
        )}
      </React.Fragment>
      {props.userObj && props.userObj.dwolla_verification_inprogress && (
        <div className="text-center pb-3 font-secondary font-size-10">
          Your account verification is in progress. Please check back in a day.
        </div>
      )}
      {props.userObj && !props.userObj?.dwolla_verification_inprogress && (
        <Formik
          validationSchema={schema}
          onSubmit={handleSubmit}
          initialValues={initialValues}
        >
          {({ handleSubmit, isValid, isSubmitting }) => (
            <form noValidate onSubmit={handleSubmit} className="w-100">
              <FormikTextField
                size="lg"
                controlId="amount1"
                label="Verify First Amount Transferred"
                type="number"
                name="amount1"
                className="mb-3"
              />
              <FormikTextField
                size="lg"
                controlId="amount2"
                label="Verify Second Amount Transferred"
                type="number"
                name="amount2"
                className="mb-3"
              />
              <div className="mb-4">
                <span className="form-label font-primary">
                  Want to
                  <a
                    onClick={() => setShowAddBankAccount(true)}
                    className="text-secondary fw-bold ms-1 font-size-4 cursor-pointer"
                  >
                    re-enter{" "}
                  </a>
                  account information?
                </span>
              </div>
              {showAddBankAccount && (
                <BankAccount
                  show={showAddBankAccount}
                  onHide={(result, response) => {
                    setShowAddBankAccount(false);
                    if (response) {
                      if (!result) {
                        toast.error(response);
                      } else {
                        handleSuccess(response);
                      }
                    }
                  }}
                  userObj={props.userObj}
                  props={props}
                ></BankAccount>
              )}
              <LoaderButton
                block
                type="submit"
                variant="primary"
                size="lg"
                text="Next"
                className="mb-2"
                isLoading={isSubmitting}
                disabled={!isValid || isSubmitting}
              >
                Next
              </LoaderButton>
            </form>
          )}
        </Formik>
      )}
    </FormImage>
  );
};

export default VerifyBankAccount;
